module.exports = __webpack_public_path__ + "static/img/icon_4.44dcf920.png";